import React, { useEffect } from 'react';
import { Loading, useFeatures } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import { find } from 'lodash';

const Home = () => {
  const history = useHistory();
  const { hasAppKickstarter } = useFeatures();
  const destinations = JSON.parse(localStorage.getItem('destinations'));

  useEffect(() => {
    if (hasAppKickstarter) {
      history.replace('/toolbox/generic');
    } else {
      const gk = find(destinations, ['name', 'Gatekeeper']);

      window.location = `${gk.url}/home`;
    }
  }, [hasAppKickstarter]);

  return (
    <Loading message="Checking roles and permissions" />
  );
};

export default Home;
